import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, ChevronDown, ChevronUp, Truck, CheckCircle, Clock, ArrowRight } from 'lucide-react';
import Header from './components/Header6';
import Footer from './components/Footer6';

const Orders6 = () => {
    const navigate = useNavigate();
    const [expandedOrder, setExpandedOrder] = useState(null);

    const orders = [
        {
            id: 'DHARTI-2026001', date: '15 Mar 2026', status: 'delivered', total: 4999,
            items: [{ name: 'Chanderi Silk Saree', quantity: 1, size: 'Free Size', price: 4999, image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' }],
            shippingAddress: '42 Heritage Lane, Amer Road, Jaipur, Rajasthan 302002',
            trackingNumber: 'DHARTI-TRK-78291', deliveredDate: '18 Mar 2026',
        },
        {
            id: 'DHARTI-2026002', date: '10 Mar 2026', status: 'in_transit', total: 6498,
            items: [
                { name: 'Khadi Cotton Kurta', quantity: 1, size: 'M', price: 2499, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=400' },
                { name: 'Block Print Anarkali', quantity: 1, size: 'S', price: 3999, image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=400' },
            ],
            shippingAddress: '15 MG Road, Bengaluru, Karnataka 560001',
            trackingNumber: 'DHARTI-TRK-78405', expectedDelivery: '22 Mar 2026',
        },
        {
            id: 'DHARTI-2026003', date: '5 Mar 2026', status: 'processing', total: 12999,
            items: [{ name: 'Banarasi Silk Saree', quantity: 1, size: 'Free Size', price: 12999, image: 'https://images.pexels.com/photos/8953474/pexels-photo-8953474.jpeg?auto=compress&cs=tinysrgb&w=400' }],
            shippingAddress: '8 Civil Lines, Varanasi, Uttar Pradesh 221002',
            trackingNumber: 'DHARTI-TRK-78512',
        },
    ];

    const statusConfig = {
        delivered: { label: 'Delivered', color: '#5D7A3A', bg: 'rgba(93,122,58,0.1)', icon: CheckCircle },
        in_transit: { label: 'In Transit', color: '#8B4513', bg: 'rgba(139,69,19,0.08)', icon: Truck },
        processing: { label: 'Processing', color: '#D4A017', bg: 'rgba(212,160,23,0.1)', icon: Clock },
    };

    const isEmpty = orders.length === 0;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Noto+Serif+Display:wght@400;600;700&family=Nunito:wght@300;400;600&display=swap');
            `}</style>
            <div style={{ fontFamily: "'Nunito', -apple-system, sans-serif" }} className="min-h-screen bg-[#F5F0E8]">
                <Header />

                <main className="pt-24 pb-16 px-4 lg:px-8">
                    <div className="max-w-[1000px] mx-auto">
                        <div className="mb-10">
                            <p className="text-xs font-semibold tracking-[3px] uppercase mb-3" style={{ color: '#8B4513' }}>Account</p>
                            <h1 style={{ fontFamily: "'Noto Serif Display', serif" }} className="text-3xl lg:text-5xl font-normal text-[#2C1810] tracking-wide">My Orders</h1>
                        </div>

                        {isEmpty ? (
                            <div className="text-center py-20">
                                <Package size={48} style={{ color: '#D4C5B0', margin: '0 auto 20px' }} />
                                <h2 style={{ fontFamily: "'Noto Serif Display', serif", fontSize: '24px', fontWeight: 400, color: '#2C1810', marginBottom: '12px' }}>No orders yet</h2>
                                <p style={{ fontSize: '14px', color: '#7C6B5D', marginBottom: '32px', fontWeight: 300 }}>Start exploring our handloom collection.</p>
                                <button onClick={() => navigate('/template6/shop')} style={{ padding: '14px 32px', backgroundColor: '#8B4513', color: '#FFFFFF', border: 'none', borderRadius: '2px', fontSize: '13px', fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', cursor: 'pointer', fontFamily: "'Nunito', sans-serif" }}>
                                    Browse Collection
                                </button>
                            </div>
                        ) : (
                            <div className="space-y-4">
                                {orders.map((order) => {
                                    const sc = statusConfig[order.status];
                                    const isExpanded = expandedOrder === order.id;
                                    return (
                                        <div key={order.id} style={{ backgroundColor: '#FAF7F2', border: '1px solid #E8DFD1', borderRadius: '4px', overflow: 'hidden' }}>
                                            <button
                                                onClick={() => setExpandedOrder(isExpanded ? null : order.id)}
                                                style={{ width: '100%', padding: '20px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left' }}
                                            >
                                                <div className="flex items-center gap-4 flex-1 min-w-0">
                                                    <div style={{ width: '48px', height: '48px', borderRadius: '8px', overflow: 'hidden', flexShrink: 0 }}>
                                                        <img src={order.items[0].image} alt="" className="w-full h-full object-cover" />
                                                    </div>
                                                    <div className="min-w-0">
                                                        <p style={{ fontSize: '15px', fontWeight: 600, color: '#2C1810', margin: '0 0 4px 0' }}>{order.id}</p>
                                                        <p style={{ fontSize: '12px', color: '#7C6B5D', margin: 0, fontWeight: 300 }}>{order.date} &middot; {order.items.length} {order.items.length === 1 ? 'item' : 'items'}</p>
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-4">
                                                    <span style={{ padding: '4px 12px', borderRadius: '2px', fontSize: '11px', fontWeight: 600, color: sc.color, backgroundColor: sc.bg, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                                                        {sc.label}
                                                    </span>
                                                    <span style={{ fontSize: '16px', fontWeight: 600, color: '#8B4513' }} className="hidden sm:inline">{`\u20B9${order.total.toLocaleString('en-IN')}`}</span>
                                                    {isExpanded ? <ChevronUp size={18} style={{ color: '#7C6B5D' }} /> : <ChevronDown size={18} style={{ color: '#7C6B5D' }} />}
                                                </div>
                                            </button>

                                            {isExpanded && (
                                                <div style={{ padding: '0 24px 24px', borderTop: '1px solid #E8DFD1' }}>
                                                    <div className="pt-4 space-y-4">
                                                        {order.items.map((item, i) => (
                                                            <div key={i} className="flex gap-4">
                                                                <div style={{ width: '64px', height: '80px', borderRadius: '3px', overflow: 'hidden', flexShrink: 0 }}>
                                                                    <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                                                                </div>
                                                                <div>
                                                                    <p style={{ fontSize: '14px', fontWeight: 600, color: '#2C1810', margin: '0 0 4px 0' }}>{item.name}</p>
                                                                    <p style={{ fontSize: '12px', color: '#7C6B5D', margin: '0 0 4px 0', fontWeight: 300 }}>Size: {item.size} | Qty: {item.quantity}</p>
                                                                    <p style={{ fontSize: '14px', fontWeight: 600, color: '#8B4513', margin: 0 }}>{`\u20B9${item.price.toLocaleString('en-IN')}`}</p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div className="mt-6 pt-4 grid grid-cols-1 sm:grid-cols-2 gap-4" style={{ borderTop: '1px solid #E8DFD1' }}>
                                                        <div>
                                                            <p style={{ fontSize: '12px', fontWeight: 600, color: '#2C1810', marginBottom: '4px', letterSpacing: '1px', textTransform: 'uppercase' }}>Shipping Address</p>
                                                            <p style={{ fontSize: '13px', color: '#7C6B5D', fontWeight: 300, lineHeight: 1.6 }}>{order.shippingAddress}</p>
                                                        </div>
                                                        <div>
                                                            <p style={{ fontSize: '12px', fontWeight: 600, color: '#2C1810', marginBottom: '4px', letterSpacing: '1px', textTransform: 'uppercase' }}>Tracking</p>
                                                            <p style={{ fontSize: '13px', color: '#8B4513', fontWeight: 600 }}>{order.trackingNumber}</p>
                                                            {order.deliveredDate && <p style={{ fontSize: '12px', color: '#5D7A3A', fontWeight: 300 }}>Delivered on {order.deliveredDate}</p>}
                                                            {order.expectedDelivery && <p style={{ fontSize: '12px', color: '#7C6B5D', fontWeight: 300 }}>Expected by {order.expectedDelivery}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Orders6;
